// @flow
import React from 'react';
import Button from './Button';

type State = {
  open: boolean
}

type Props = {
  children?: any,
  className: string,
  label: string,
  noBorder: boolean
}

class Dropdown extends React.Component {
  state: State = {
    open: false
  }

  props: Props

  render() {
    const { children, className, label, noBorder } = this.props;
    return (
      <div className={`
        ${className} 
        custom-dropdown 
        ${noBorder && 'no-border'}`}
      >
        <Button
          id='custom-dropdown__toggle'
          className={`
            ${className}__toggle 
            custom-dropdown__toggle
            ${this.state.open ? 'is-chevron--up' : 'is-chevron--down'}`}
          onClick={() => this.setState({ open: !this.state.open })}
          label={label}
        />
        {this.state.open && children }
      </div>
    );
  }
}

export default Dropdown;


// WEBPACK FOOTER //
// ./src/components/shared/DropdownCustom.js